import { ImageStepper } from '@epilot/concorde-elements'
import type { Product } from '@epilot/journey-logic-commons'

import { useConfig } from '../../../../../blocks-renderers/providers/ConfigContext'
import { useOptimizedProductImages } from '../../../../utils/hooks'
import { DefaultProductImage } from '../../../ProductSelectionControl/components/TileHeader/ProductImageRenderer/DefaultProductImage'
import { ProductImage } from '../../../ProductSelectionControl/components/TileHeader/ProductImageRenderer/ProductImage'

import classes from './ProductDetailsImage.module.scss'

type ProductDetailsImageProps = {
  product: Product
  showImageGallery?: boolean
}

/**
 * This component is functionally equivalent to the ProductImageRenderer
 * @see apps/journey-app-v3/src/concorde-renderers/renderers/ProductSelectionControl/components/TileHeader/ProductImageRenderer/ProductImageRenderer.tsx
 * @todo Should simplify into a single component
 */
export const ProductDetailsImage = ({
  product,
  showImageGallery = true
}: ProductDetailsImageProps) => {
  const { IMAGE_PREVIEW_API_URL } = useConfig()
  const optimizedImages = useOptimizedProductImages(
    product,
    IMAGE_PREVIEW_API_URL
  )

  const productName = product.name

  if (optimizedImages.length === 0 || !IMAGE_PREVIEW_API_URL) {
    return (
      <div className={classes.imageWrapper}>
        <DefaultProductImage alt={productName} className={classes.image} />
      </div>
    )
  } else if (optimizedImages.length === 1 || !showImageGallery) {
    const image = optimizedImages[0]

    return (
      <div className={classes.imageWrapper}>
        <ProductImage
          alt={productName}
          className={classes.image}
          image={image}
        />
      </div>
    )
  } else {
    return (
      <div className={classes.imageWrapper}>
        <ImageStepper images={optimizedImages} />
      </div>
    )
  }
}
